export const convertTiersToArray = (tiers) => {
  const convertedTiers = [...tiers].map(({ to, royaltyPercentage }) => ([to, 100 - royaltyPercentage]));

  // The format for storing the tiers is in reverse order, where the top tier comes first
  return convertedTiers.reverse();
};

const convertTiersToObject = (tiers) => {
  if (!tiers.every(tier => Array.isArray(tier))) {
    return tiers;
  }

  let startingTierAmount = 0;
  const actualTiers = [];

  [...tiers].reverse().forEach(([to, brokerageSplit]) => {
    actualTiers.push({
      from: startingTierAmount,
      to,
      royaltyPercentage: 100 - brokerageSplit,
    });

    startingTierAmount = to;
  });

  return actualTiers;
};

export const convertedScheduleTiers = (schedule, defaultRoyaltyPatterns) => {
  let tiers = schedule.tiers;

  if (schedule.royaltyPatternName !== 'custom') {
    tiers = defaultRoyaltyPatterns[schedule.royaltyPatternName];
  }

  return convertTiersToObject(tiers);
};

export const cleanTierValues = (tiers) => {
  let startingTierAmount = 0;

  return [...tiers].map((tier) => {
    const cleanTier = {
      ...tier,
      from: startingTierAmount
    };

    startingTierAmount = tier.to;

    return cleanTier;
  });
};
